var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    stroke: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8829 17.1176V15.1176L21.0005 20.0588L13.1182 15.1176V17.1176L21.0005 21.9411L28.8829 17.1176ZM28.8829 13.1176C29.3927 13.1176 29.8437 13.3333 30.2358 13.7647C30.628 14.196 30.8044 14.647 30.7652 15.1176V26.8823C30.7652 27.3921 30.5888 27.8431 30.2358 28.2353C29.8829 28.6274 29.4319 28.8431 28.8829 28.8823H13.1182C12.6084 28.8823 12.1574 28.6666 11.7652 28.2353C11.3731 27.8039 11.1966 27.3529 11.2358 26.8823V15.1176C11.2358 14.6078 11.4123 14.1568 11.7652 13.7647C12.1182 13.3725 12.5691 13.1568 13.1182 13.1176H28.8829Z",
    fill: "#7D7D7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxGrey);
export default __webpack_public_path__ + "static/media/inbox-grey.1985d981ce32a3d46a78d50c34c5fba6.svg";
export { ForwardRef as ReactComponent };